var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import './style.css';
import { Image } from '@syllepsis/plugin-basic';
import { Card, InlineCard } from '../../../card';
import { ImageMask } from './mask';
import { ImageComponent, InlineImageComponent } from './template';
var ImageView = /** @class */ (function (_super) {
    __extends(ImageView, _super);
    function ImageView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ViewMap = {
            template: ImageComponent,
            mask: ImageMask
        };
        _this.NodeView = Card.prototype.NodeView;
        return _this;
    }
    return ImageView;
}(Image));
var InlineImageView = /** @class */ (function (_super) {
    __extends(InlineImageView, _super);
    function InlineImageView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'inline';
        _this.inline = true;
        _this.ViewMap = {
            template: InlineImageComponent,
            mask: ImageMask
        };
        _this.NodeView = InlineCard.prototype.NodeView;
        return _this;
    }
    return InlineImageView;
}(Image));
export { ImageView, InlineImageView };
//# sourceMappingURL=index.js.map